<template>
  <div class="with-content content-accordion faq-accordion" role="tablist" @click.prevent>
    <HighlightText
      :text="query"
      @matched="openPanelAt(index)"
      @noMatch="closePanelAt(index)"
      class="card"
      v-for="(item, index) in items"
      :key="index"
    >
      <div class="card-header" role="tab">
        <a href="#" class="accordion-title collapsed" v-b-toggle="`faq${index}`">
          <span>{{ item.title }}</span>
          <span class="icon-arrow-down32 float-end" />
          <span class="icon-arrow-up32 float-end" />
        </a>
      </div>
      <BCollapse :id="`faq${index}`" :accordion="query ? String(index) : 'faq'" class="fade" ref="panels">
        <div class="card-body" v-html="item.content" />
      </BCollapse>
    </HighlightText>
  </div>
</template>

<script>
import HighlightText from './HighlightText';
import { BCollapse } from 'bootstrap-vue-next';

export default {
  props: ['items', 'query'],
  components: {
    BCollapse,
    HighlightText,
  },
  methods: {
    togglePanelAt(index, isVisible) {
      const panel = this.$refs.panels[index];

      if (panel.show !== isVisible) {
        panel.toggle();
      }
    },

    openPanelAt(index) {
      if (this.$refs.panels && this.$refs.panels[index]) {
        this.togglePanelAt(index, true);
      }
    },

    closePanelAt(index) {
      if (this.$refs.panels && this.$refs.panels[index]) {
        this.togglePanelAt(index, false);
      }
    },
  },
};
</script>

<style scoped lang="scss">
:deep(.card-body) {
  font-size: 1.125rem;
  line-height: 1.77;

  > ul li {
    font-size: 1.125rem;
  }
}
</style>
